import styled from "styled-components";
export const primary = "#341744";
export const secondary = "#cb5499";
